import { Stack } from '@mui/material'
import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { Button, InformationModal } from 'utoniq-ui'

import { BottomSafeArea } from '@/components/layouts'
import { useMessage, useRouter, useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

import { CreateEventValue } from '../EventCreateForm'

export type FixedButtonAreaProps = {
  mode: 'update' | 'create'
  method: UseFormReturn<CreateEventValue>
  onSubmit: (values: CreateEventValue) => Promise<void>
}

export const FixedButtonArea: Cell<FixedButtonAreaProps> = ({
  mode,
  method,
  onSubmit,
}) => {
  const { t } = useTranslation('consoleEventCreate')
  const { router } = useRouter()
  const { showMessage } = useMessage()
  const [openConfirm, setOpenConfirm] = useState<boolean>(false)
  const [openCancel, setOpenCancel] = useState<boolean>(false)
  const {
    formState: { isValid, isSubmitting, isDirty },
    handleSubmit,
  } = method

  return (
    <BottomSafeArea sx={{ bgcolor: 'grey.50' }}>
      <Stack py={4} spacing={2} alignItems="center" sx={{ bgcolor: 'grey.50' }}>
        <Button
          size="large"
          color="primary"
          sx={{ width: 244 }}
          onClick={handleSubmit(() => setOpenConfirm(true))}
          disabled={!isValid || isSubmitting}
        >
          {t(mode)}
        </Button>
        <Button
          size="medium"
          variant="text"
          color="primary"
          sx={{ width: 244 }}
          onClick={() => {
            if (isDirty) {
              return setOpenCancel(true)
            }
            router.goBack()
          }}
        >
          {t('cancel', 'キャンセル')}
        </Button>
      </Stack>
      <InformationModal
        title={t(`${mode}EventModalTitle`)}
        content={t(`${mode}EventModalDesc`)}
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        cancelText={t('close')}
        buttons={
          <Button
            color="primary"
            size="large"
            onClick={handleSubmit(async values =>
              onSubmit(values).finally(() => setOpenConfirm(false))
            )}
            sx={{ minWidth: 212 }}
            loading={isSubmitting}
          >
            {t(`${mode}EventBtn`)}
          </Button>
        }
      />
      <InformationModal
        title={t(`${mode}CancelCreateEventModalTitle`)}
        content={t(`${mode}CancelCreateEventModalDesc`)}
        open={openCancel}
        onClose={() => setOpenCancel(false)}
        cancelText={t('close')}
        buttons={
          <Button
            color="primary"
            size="large"
            onClick={() => {
              showMessage(t(`${mode}CancelCreateEventSuccess`), 'success')
              router.goBack()
            }}
            sx={{ minWidth: 212 }}
          >
            {t(`${mode}CancelCreateEventBtn`)}
          </Button>
        }
      />
    </BottomSafeArea>
  )
}
